import React from "react";

import Switch from "antd/es/switch";
import { defineMessages, useIntl } from "react-intl";

import styles from "./PhiSwitch.module.scss";

const messages = defineMessages({
  label: {
    id: "settings.manageFields.editPane.fieldAccess.phi.label",
    defaultMessage: "Enable PHI field access options (HIPAA)",
    description: "PHI switch label in Manage Fields",
  },
  note: {
    id: "settings.manageFields.editPane.fieldAccess.phi.note",
    defaultMessage:
      "Any no access fields will be treated as PHI (Protected Health Information). Enabling this setting does not automatically meet compliance standards - it only allows you to take the necessary steps to be HIPAA compliant.",
    description: "PHI switch note",
  },
});

interface Props {
  onChange?: (value: boolean) => void;
  value?: boolean;
}

const PhiSwitch: React.FC<Props> = ({ onChange, value }) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <label className={styles.label}>
        <div>{intl.formatMessage(messages.label)}</div>
        <Switch checked={value} onChange={onChange} />
      </label>
      {value && <div className={styles.note}>{intl.formatMessage(messages.note)}</div>}
    </div>
  );
};

export default PhiSwitch;
